import { useState, useRef,useEffect } from 'react';
import plus from "./imgs/plus.png";
import { decoderOperation, fetchUserDecoders } from '../../service/subscribers/subscribersApi';
import { checkDecoderId } from "../utils/checkDecoderId";
import ModalMessage from "../components/ModalMessage";
import DeleteDecoderButton from "../components/DeleteDecoderButton";

const NumberInputList = ({id, onDecodersChanged}) => {
    const [decoderList, setDecoderList] = useState([]);
    const [deletable, setDeletable] = useState([]);

    const fetchDecoders = async () => {
        const data = await fetchUserDecoders(id);
        setDecoderList(data.decoders);
        setDeletable(data.deletable);
    }

    useEffect(() => {
        fetchDecoders();
    }, [id, onDecodersChanged]);

    const regionRefs = useRef([]);
    const inputRefs = useRef([]);
    const [regionList, setRegionList] = useState([]);
    const [inputList, setInputList] = useState([]);
    const [readOnlyStatus, setStatus] = useState([]);

    const [modal, showModal] = useState(false);
    
    ///////////////////////////////
    //fetch POST
    const decoderOperations = async (operation, decoder, index) => {  
        try{
            await decoderOperation(operation, id, decoder);
            onDecodersChanged?.();
            const statusList = [...readOnlyStatus];
            statusList[index] = true;
            setStatus(statusList);            
        }
        catch(error){
            showModal(true);
            console.error('Error: ', error);
        }
    } 

    /////////////////////////////////////////////////////////////
    //adding new input
    const handleAddInput = () => {
      setRegionList([...regionList, '']);
      setInputList([...inputList, '']);
      setStatus([...readOnlyStatus, false]);
    };

    /////////////////////////////////////////////////////////////
    //saving values
    const regionFormChange = (index, value) => {
        const updated = [...regionList];
        updated[index] = value;
        setRegionList(updated);
        if(updated[index].length >= 2) regionRefs.current[index].blur();
    }
    const focusNext = (index) => {
        inputRefs.current[index].focus();
    }
    const handleInputChange = (index, value) => { 
        const updatedInputList = [...inputList];
        updatedInputList[index] = value;
        setInputList(updatedInputList);
    };

    /////////////////////////////////////////////////////////////
    //removing inputs from system or just from the interface
    const handleRemoveInput = (index) => {
        if(readOnlyStatus[index] === true) decoderOperations('DELETE', regionList[index] + "-" + inputList[index], index); 

        const updated = [...regionList];
        const updatedInputList = [...inputList];
        const read = [...readOnlyStatus];
        
        updated.splice(index, 1);
        updatedInputList.splice(index, 1);
        read.splice(index, 1);

        setRegionList(updated);
        setInputList(updatedInputList);
        setStatus(read);
    };

    /////////////////////////////////////////////////////////////
    //removing опечатки
    
    /////////////////////////////////////////////////////////////
    //saving changes
    const blurr = (event, index, value) => {
        event.preventDefault();
        const updated = [...readOnlyStatus];
        if(inputRefs.current[index].value.length < 1) handleRemoveInput(inputList.length - 1);
        else if(updated[index] === false){
            if(regionList.length > decoderList.length) {
                const dat = regionList[index] + "-" + value;
                if(checkDecoderId(dat)){ 
                    decoderOperations('PUT', dat, index);
                    updated[index] = true;
                }else{
                    handleRemoveInput(index);
                    showModal(true);
                }
            }
        }
        setStatus(updated);
    }
    const handleEnterPress = (event, index, value) => {
        if (event.key === 'Enter') {
            blurr(event, index, value);
        }
    };

    useEffect(() => {
        const conveterAndSaver = () => {
            const updatedDec = [];
            const updatedReg = [];
            for(let i = 0; i < decoderList.length; i++) {
                const regordec = decoderList[i].decoder_id.split("-");
                updatedReg.push(regordec[0]);
                updatedDec.push(regordec[1]);     
            };
            setRegionList(updatedReg);
            setInputList(updatedDec);
            setStatus(decoderList.map(elem => true))
        }
        conveterAndSaver();
    }, [decoderList])
    
    /////////////////////////////////////////////////////////////
    return (
        <div>
            {inputList && inputList.map((input, index) => (
                <div className='decAdders' key={index}>
                  <input
                    type="text" 
                    className="region-input" 
                    autoFocus
                    ref={(el) => (regionRefs.current[index] = el)}
                    onBlur={() => {focusNext(index)}}
                    onChange={(e) => regionFormChange(index, e.target.value)}
                    value={regionList[index]}
                    readOnly={readOnlyStatus[index]} />
                  -  
                  <input
                      ref={(el) => (inputRefs.current[index] = el)}
                      type="text"
                      className="decoder-input"
                      value={input}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      onKeyDown={(e) => handleEnterPress(e, index, input)}
                      onBlur={(e) => {blurr(e, index, input)}}                 
                      readOnly={readOnlyStatus[index]}      
                  />
                  <DeleteDecoderButton
                    canDelete={deletable[index]}
                    onConfirmDelete={() => handleRemoveInput(index)}
                  />
                </div>
            ))}
            {modal && (
                <ModalMessage
                    title="Error"
                    message="There is no decoder with this number or it is already in use"
                    actions={<button className="error-btn" onClick={() => {showModal(false)}}>Retry</button>}
                />
            )}
            <div style={{
                display: 'flex',
                alignItems: 'center',
            }}><button onClick={() => {handleAddInput()}} className="plus-btn"><img src={plus} alt="plus" /></button>add decoder</div>
        </div>
    );
};

export default NumberInputList;

